// Add some context...
/** @deprecated */
const bindAll = <T extends object, K extends keyof T>(obj: T, names: K[]): void => {
  names.forEach(fn => {
    obj[fn] = (obj[fn] as unknown as Function).bind(obj);
  });
};

export default bindAll;
